import React from "react";
var __jsx = React.createElement;
import { Dialog, DialogContent } from "@/components/Dialog";
import { Icon } from "@syarahtech/ui";
var PostInfoModal = function PostInfoModal(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog, {
    open: show,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    }
  }, /*#__PURE__*/React.createElement(DialogContent, {
    className: "lg:min-w-[clamp(33.25rem,_-24.9038rem_+_90.8654cqi,_56.875rem)] p-6",
    haveClose: false,
    overlayClassName: "z-[9999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute en:left-[unset] left-4 en:right-4 top-4 rounded-sm focus:outline-none disabled:pointer-events-none bg-transparent border-none",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-[#4D4D4F] cursor-pointer"
  })), children)));
};
export default PostInfoModal;